<template>
  <div>
    <h1>Call発番作業ウィザード</h1>
    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="商談ID" v-model="sfOpportunityId" />
        <button class="btn btn-other-action" @click="loadSfOpportunity">SFから読み込み</button>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="ショップID" v-model="shopId" />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="医院名" v-model="name" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="フォロー担当者" v-model="follow" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="呼び名" v-model="nameRuby" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="SF取引先より、取引先情報>電話" v-model="phone" />
      </div>
      <div class="form-group col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="SF取引先より、住所情報>住所を都道府県からスペースなし" v-model="address" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="開始希望日yyyy-mm-dd" v-model="startHopeDate" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <select id="plan" class="form-control" v-model="selectedPlan">
          <option disabled value="">プランを選択</option>
          <option v-for="plan in plans" :key="plan.title" :value="plan.title">
            {{ plan.title }}
          </option>
        </select>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6" v-for="(option, idx) in options" :key="idx">
        <input type="checkbox" :id="'option_' + idx" v-model="checkedOptions[idx]" />
        <label :for="'option_' + idx">{{ option.title }}</label>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <select id="operator" class="form-control" v-model="selectedOperator">
          <option disabled value="">AIオペレータを選択</option>
          <option v-for="operator in operators" :key="operator.name" :value="operator.name">
            {{ operator.name }}
          </option>
        </select>
      </div>
    </div>

    <div v-if="currentStep === 0">
      <h2>2. 事前確認</h2>
      <ol>
        <li v-if="settingCallCenterTransfer !== checkedOnCallCenterTransfer">
          コールセンター転送は実施するのか、しないのか
        </li>
        <li v-if="checkedOnLine || checkedOnSms">
          CXの契約確認（CXと期間の重複したLINE,SMSオプションはNG）
        </li>
        <li v-if="checkedOnLine && !checkedOnSms">
          LINEやる場合はSMSもセットになる（SMSやる場合にLINEは必須ではない）
        </li>
      </ol>
    </div>

    <div v-if="currentStep === 1">
      <h2>3. シナリオ作成</h2>
      <ol>
        <li>
          Commuboの左メニュー>会話シナリオを選択
        </li>

        <li>
          以下のシナリオの「詳細・削除」を押し、<br>
          バージョンのバックナンバー一覧から「適用中」のもので「新規シナリオに複製」を押す<br>
          <table class="table table-striped">
            <thead>
            <tr>
              <th>シナリオ名</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>★【カレンダー連携】gpt医院名＋OLショップID＋プラン名</td>
            </tr>
            </tbody>
          </table>
        </li>

        <li>
          会話シナリオ名は
          <div class="row">
            <div class="form-group col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <input class="form-control" type="text" readonly :value="scenarioName" />
              <input type="button" value="コピー" class="btn btn-other-action" @click="copy(scenarioName)" />
            </div>
          </div>
        </li>
      </ol>
    </div>

    <div v-if="currentStep === 2">
      <h2>4. 会話シナリオデータ編集</h2>
      <ol>
        <li>
          会話シナリオより、「会話シナリオデータを編集」を押し、<br>
          DFD（とは違うか）の左端の方にある「医院情報設定」を押す
        </li>

        <li>
          コンテキストごとに登録できる文字を指定できるため、以下を入力する
          <ul>
            <li>hospital_name：{{ name }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(name)" /></li>
            <li v-if="checkedOnCallCenterTransfer">transfer：{{ checkedOnCallCenterTransfer === true ? 'yes' : '' }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy('yes')" /></li>
          </ul>
        </li>

        <li>
          「AIオペレータ発話を追加」を押し、テキストボックスに医院名を入力して「発話音声をプレビュー」<br>
          それが<strong>{{ nameRuby }}</strong>と一致するか、イントネーションや発音が正しいか確認する<br>
          調整は<a href="https://www.notion.so/kitchen-drunkard/Call-1dca07dfe79680edbe96dd36ccaaede1?source=copy_link#1dca07dfe7968057ab66f36f961a0c06" target="_blank">notion</a>を参照<br>
          調整の結果をspeak_hospital_nameに記述して、<strong>必ず「AIオペレータの発話」を削除する</strong>
        </li>

        <li>
          以上の登録ができたら「OK」を押し、<br>
          画面の右上より、「バージョン登録して保存」を押す<br>
          バージョンはシナリオ作成でもとにしたテンプレートのメジャーバージョンを使う<br>
          つまり、5.0.50ならば5.0.0を指定する
          <input type="button" value="コピー" class="btn btn-other-action" @click="copy('5.0.0')" />
        </li>
      </ol>
    </div>

    <div v-if="currentStep === 3">
      <h2>5. 会話インタフェースの紐づけ</h2>
      シナリオとインターフェース（電話番号）を紐づける
      <ol>
        <li>
          Commubo左メニューより設定>会話インタフェース<br>
          5ページ目あたりのインタフェース名「スマートチェックアウト～」の中から一つを選び「詳細」>「編集」を押して変更する
          <table class="table table-striped">
            <tbody>
            <tr>
              <td>会話インタフェース名</td>
              <td>{{ interfaceName }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(interfaceName)" /></td>
            </tr>
            <tr>
              <td>着信シナリオ名</td>
              <td>{{ scenarioName }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(scenarioName)" /></td>
            </tr>
            <tr>
              <td>着信対応AIオペレータ名</td>
              <td>{{ operatorName }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(operatorName)" /></td>
            </tr>
            </tbody>
          </table>
        </li>
      </ol>
    </div>

    <label class="control-label" v-if="currentStep >= 3">Commubo</label>
    <div class="row" v-if="currentStep >= 3">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="会話インタフェースID" v-model="interfaceId" />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="発番電話番号" v-model="interfaceTel" />
      </div>
    </div>

    <div v-if="currentStep === 4">
      <h2>6. コールセンターへの申し送り</h2>
      <div v-if="checkedOnCallCenterTransfer">
        <ol>
          <li>
            <a href="https://docs.google.com/spreadsheets/d/1ph_UsTjeN8STsY5tRoDV06dAo6l-6xEQn62nlf3ZDIM/edit?gid=66450166#gid=66450166" target="_blank">SCOxグッドクロス管理表</a>に対象加盟店を記載する<br>
            <input type="text" readonly :value="gcManagementTxt" />
            <input type="button" value="コピー" class="btn btn-other-action" @click="copy(gcManagementTxt)" />
          </li>
          <li>
            複数件あるならまとめて実施でもよいが、<strong>絶対に忘れないよう</strong><br>
            メールの内容については<a href="https://www.notion.so/kitchen-drunkard/Call-1dca07dfe79680edbe96dd36ccaaede1?source=copy_link#1dca07dfe7968057ab66f36f961a0c06" target="_blank">notion</a>を参照<br>
          </li>
        </ol>
      </div>
      <div v-else>
        コールセンター転送のオプションが設定されないので、ここでの作業は不要
      </div>
    </div>

    <div v-if="currentStep === 5">
      <h2>7. SF商談の更新</h2>
      SF商談「Pay Light Call」を更新する
      <ol>
        <li>
          発番電話番号：{{ interfaceTel }}
          <input type="button" value="コピー" class="btn btn-other-action" @click="copy(interfaceTel)" />
        </li>
        <li>
          会話インターフェースID：{{ interfaceId }}
          <input type="button" value="コピー" class="btn btn-other-action" @click="copy(interfaceId)" />
        </li>
        <li>
          シナリオステータス：シナリオ作成済み
        </li>
      </ol>
    </div>

    <div v-if="currentStep === 6">
      <h2>8. スプレッドシート更新</h2>
      <a href="https://docs.google.com/spreadsheets/d/1GNuceXzjbQfGpNgfR6FXTaSdfn1zJnO-h9zESQ189kA/edit?resourcekey=&gid=1463596933#gid=1463596933&range=A1100" target="_blank">PayLightCall連携SS</a>に以下を記載する<br>
      <input type="text" readonly :value="opsCallStartTxt" />
      <input type="button" value="コピー" class="btn btn-other-action" @click="copy(opsCallStartTxt)" />
    </div>

    <div v-if="currentStep === 7">
      <h2>9. glenfiddichへのデータ登録</h2>
      <textarea readonly class="form-control" rows="5">{{ opsCallRequestTxt }}</textarea>
      <input type="button" value="コピー" class="btn btn-other-action" @click="copy(opsCallRequestTxt)" />
    </div>

    <div v-if="currentStep === 8">
      <h2>10. SF商談更新</h2>
      SF商談「Pay Light Call」を更新する
      <ol>
        <li>
          シナリオステータス：システム連携済み
        </li>
        <li v-if="checkedOnCallCenterTransfer">
          グッドクロス連携済み：チェック
        </li>
      </ol>
    </div>

    <div v-if="currentStep === 9">
      <h2>11. 営業担当者に作業完了を報告</h2>
      <textarea readonly :value="finishReportTxt" class="form-control" rows="5"></textarea>
    </div>

    <button class="btn btn-other-action" @click="beforeStep">前工程</button>
    <button class="btn btn-other-action" @click="nextStep">次工程</button>
  </div>
</template>

<style scoped>
</style>

<script>
const plans = [
  { title: 'ライト' },
  { title: 'スタンダード' },
  { title: 'メガ' },
  { title: 'エンタープライズ' },
]
const options = [
  { title: 'カスタムシナリオ利用', key: 'customScenario' },
  { title: '独自シナリオ製作・利用', key: 'originalScenario' },
  { title: 'コールセンター転送', key: 'callCenterTransfer' },
  { title: '予約システムURL送付SMS', key: 'sms' },
  { title: 'LINEオプション', key: 'line' }
]
const operators = [
  { name: '標準', commubo: 'AIロボットのコミュボ-女性(ハキハキした声)' },
  { name: '高級向け', commubo: '高級向け - 女性(ハキハキした声)' },
  { name: '高齢者向け', commubo: '高齢者向け - 女性(ハキハキした声)' }
]

export default {
  data() {
    return {
      currentStep: 0,
      plans,
      options,
      operators,
      callCenterCheckIdx: options.findIndex(opt => opt.key === 'callCenterTransfer'),
      smsCheckIdx: options.findIndex(opt => opt.key === 'sms'),
      lineCheckIdx: options.findIndex(opt => opt.key === 'line'),
      checkedOptions: Array(options.length).fill(false),
      selectedPlan: '',
      selectedOperator: '',
      startHopeDate: '',
      name: '',
      nameRuby: '',
      sfOpportunityId: '',
      shopId: '',
      phone: '',
      address: '',
      interfaceTel: '',
      interfaceId: '',
      settingCallCenterTransfer: false,
      follow: ''
    }
  },
  computed: {
    scenarioName() {
      const scenarioNameSuffix = '【カレンダー連携】gpt'
      return `${this.name}${this.shopId}${this.selectedPlan}${scenarioNameSuffix}`
    },
    interfaceName() {
      return `${this.name}${this.shopId}`
    },
    operatorName() {
      const operator = this.operators.find(op => op.name === this.selectedOperator)
      return operator ? operator.commubo : '未選択'
    },
    gcManagementTxt() {
      return `${this.shopId}\t${this.name}\t${this.nameRuby}\t${this.phone}\t${this.address}\t${this.interfaceTel}`
    },
    opsCallStartTxt() {
      const today = new Date().toISOString().split('T')[0].replace(/-/g, '/')
      const status = 'システム部依頼中'
      return `=ROW()-3\t${this.shopId}\t${this.name}\t${this.interfaceId}\t${this.interfaceTel}\t${today}\t${status}`
    },
    opsCallRequestTxt() {
      return '@ops No.**のCall連携作業をお願いします。'
    },
    finishReportTxt() {
      return [
        `@${this.follow}へのメンション`,
        `${this.name}～SFのCall商談リンクを添えて～ さま`,
        `のCall発番完了しました。`,
        `医院さまと発話内容のご確認等お願いいたします。`
      ].join('\n')
    },
    checkedOnCallCenterTransfer() {
      return this.checkedOptions[this.callCenterCheckIdx]
    },
    checkedOnSms() {
      return this.checkedOptions[this.smsCheckIdx]
    },
    checkedOnLine() {
      return this.checkedOptions[this.lineCheckIdx]
    }
  },
  methods: {
    beforeStep() {
      if (this.currentStep > 0) {
        this.currentStep--
      }
    },
    nextStep() {
      if (this.currentStep < 9) {
        this.currentStep++
      }
    },
    loadSfOpportunity() {
      if (!this.sfOpportunityId) {
        alert('商談IDを入力してください。')
        return
      }

      console.log(`Loading SF Opportunity with ID: ${this.sfOpportunityId}`)

      const unixtime = Math.floor(Date.now() / 1000)
      fetch(`/api/v1/sfo_call/?id=${this.sfOpportunityId}&tv=${unixtime}`)
          .then(response => {
            if (!response.ok) throw new Error('データ取得に失敗しました')
            return response.json()
          })
          .then(data => {
            this.shopId = data.shopId || ''
            this.name = data.name || ''
            this.nameRuby = data.nameRuby || ''
            this.phone = data.phone || ''
            this.address = data.address || ''
            this.startHopeDate = data.startHopeDate || ''

            this.selectedOperator = data.operator || ''
            this.selectedPlan = data.plan || ''
            this.options.forEach((opt, idx) => {
              this.checkedOptions[idx] = data.options[opt.key] || false
            })
            this.settingCallCenterTransfer = data.settings.callCenterTransfer
            this.follow = data.follow
          })
          .catch(error => {
            alert(error.message)
          })
    },
    copy(text) {
      navigator.clipboard.writeText(text)
    }
  }
}
</script>